import React from 'react';
import { Button } from '../ui/button';
import { AVAILABILITY_META, roleLabel, initials, avatarColor } from './opsMeta';

const rateCls = (r) => (r >= 70 ? 'text-emerald-700 bg-emerald-50 ring-emerald-200'
  : r >= 40 ? 'text-amber-700 bg-amber-50 ring-amber-200'
    : 'text-red-700 bg-red-50 ring-red-200');

// Tableau « Charge par opérateur ».
export const OperatorWorkloadTable = ({ operators = [], onAssign }) => (
  <div className="rounded-xl border border-gray-200 bg-white shadow-sm" data-testid="ops-operator-workload">
    <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
      <h2 className="text-base font-semibold tracking-tight text-gray-900">Charge par opérateur</h2>
      <span className="text-xs font-medium text-emerald-600">{operators.length} opérateur(s)</span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[11px] uppercase tracking-wide text-gray-400">
            <th className="px-5 py-2 text-left font-medium">Opérateur</th>
            <th className="px-2 py-2 text-left font-medium">Rôle</th>
            <th className="px-2 py-2 text-center font-medium">Actives</th>
            <th className="px-2 py-2 text-center font-medium">Retards</th>
            <th className="px-2 py-2 text-center font-medium">Livrées</th>
            <th className="px-2 py-2 text-center font-medium">Taux réussite</th>
            <th className="px-2 py-2 text-center font-medium">Disponibilité</th>
            <th className="px-5 py-2 text-right font-medium">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {operators.map((o) => {
            const avail = AVAILABILITY_META[o.availability?.key] || AVAILABILITY_META.disponible;
            return (
              <tr key={o.operatorId} className="transition-colors hover:bg-gray-50/60" data-testid={`ops-operator-row-${o.operatorId}`}>
                <td className="px-5 py-2.5">
                  <div className="flex items-center gap-2.5">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white ${avatarColor(o.operatorId)}`}>
                      {initials(o.operatorName)}
                    </span>
                    <span className="font-medium text-gray-800">{o.operatorName}</span>
                  </div>
                </td>
                <td className="px-2 py-2.5 text-gray-500">{roleLabel(o.role)}</td>
                <td className="px-2 py-2.5 text-center font-semibold tabular-nums text-gray-800">{o.ongoing}</td>
                <td className="px-2 py-2.5 text-center">
                  {o.late > 0
                    ? <span className="inline-flex min-w-[1.75rem] justify-center rounded-md bg-red-50 px-1.5 py-0.5 text-xs font-semibold text-red-600 ring-1 ring-red-200">{o.late}</span>
                    : <span className="text-gray-300">0</span>}
                </td>
                <td className="px-2 py-2.5 text-center tabular-nums text-gray-600">{o.delivered}</td>
                <td className="px-2 py-2.5 text-center">
                  <span className={`inline-flex rounded-md px-2 py-0.5 text-xs font-semibold ring-1 ${rateCls(o.deliveryRate)}`}>{o.deliveryRate}%</span>
                </td>
                <td className="px-2 py-2.5 text-center">
                  <span className={`inline-flex rounded-md px-2 py-0.5 text-xs font-medium ring-1 ${avail.cls}`}>{avail.label}</span>
                </td>
                <td className="px-5 py-2.5 text-right">
                  <Button
                    size="sm"
                    variant="outline"
                    className="h-7 px-3 text-xs"
                    onClick={() => onAssign && onAssign(o)}
                    data-testid={`ops-operator-assign-${o.operatorId}`}
                  >
                    Assigner
                  </Button>
                </td>
              </tr>
            );
          })}
          {operators.length === 0 && (
            <tr><td colSpan={8} className="px-5 py-10 text-center text-gray-400">Aucun opérateur</td></tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default OperatorWorkloadTable;
